import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-offer-list',
  templateUrl: './offer-list.component.html',
  styleUrls: ['./offer-list.component.css']
})
export class OfferListComponent implements OnInit {

  OfferData: any = []
  cid:any
  form: any | FormGroup
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  scheduleId = ""
  singleOfferData: any = []
  params:any = []
  possibleValue:any = []
  paramSelected = ""
  possibleValueSelected = ""
  offerId = 0;
  offerName = ""
  whatsappScheduleName = ""
  marketingDataUser:any = []
  keyAndValue:any = []
  keyValueSearched = false
  // paramsDropdownList  = [];
  // paramsSelectedItems:any = [];
  // paramsDropdownSettings:IDropdownSettings = {
  //   singleSelection: false,
  //   idField: 'id',
  //   textField: 'name',
  //   selectAllText: 'Select All',
  //   unSelectAllText: 'UnSelect All',
  //   itemsShowLimit: 3,
  //   allowSearchFilter: true
  // };


  // possibleValueDropdownList  = [];
  // possibleValueSelectedItems:any = [];
  // possibleValueDropdownSettings:IDropdownSettings = {
  //   singleSelection: false,
  //   idField: 'id',
  //   textField: 'name',
  //   selectAllText: 'Select All',
  //   unSelectAllText: 'UnSelect All',
  //   itemsShowLimit: 3,
  //   allowSearchFilter: true
  // };
  userSelectCount = 0;
  userSearchInput = "";
  userRoles:any = []
  index = 0;
  userList:any = []
  customersList:any = []
  usersList_2:any = []
  paramList:any = [
    {
      "id": 0,
      "name": "",
      "possibleValue": [],
      "possibleValueSelected": ""
    }
  ]

  customerParamList:any = [
    {
      "id": 0,
      "name": "",
      "possibleValue": [],
      "possibleValueSelected": ""
    }
  ]
  usersType = "Customer users"
  isLoading: any = false
  addButton = false;
  formSubmitted = false;
  editFormSubmitted = false;
  editForm: any | FormGroup

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllOffer()
    this.getParams()
    this.form = this.fb.group({
      name: [''],
      description: [''],
    })

    this.editForm = this.fb.group({
      name: ['',[Validators.required]],
      description: ['',[Validators.required]],
    })
  }

  addOffer(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addOffer(body).subscribe(
      (response:any) => {
        this.getAllOffer()
        this.cancelModel()
        this.form.reset()
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllOffer();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeAdd")?.click()
  }

  getAllOffer(){
    this.isLoading = true

    this.generic_service.getAllOffer().subscribe(
      (res:any)=> {
        console.log(res);
        this.OfferData = res.response
        this.count = res.response.length
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getOfferById(id:any,offerName:any){
    this.offerId = Number(id);
    this.offerName = offerName
    this.generic_service.getOfferById(id).subscribe(
      (res:any)=>{
        this.singleOfferData = []
        this.singleOfferData.push(res.response)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  selectList(){
    document.getElementById("openListModal")?.click()
  }

  getUsers(type:any,i:any){
    this.index = Number(i)
    if(type != ''){
      this.generic_service.getUserByType(type).subscribe(
        (response:any)=>{
          for(let i = 0;i<response.response.length;i++){
            response.response[i].isChecked = false;
          }
          this.userList = response.response;
          this.selectList()
        },
        (err:any)=>{
          console.log(err)
        }
      )
    }
  }



  userSelected(index:any,event:any){
    this.userList[index].isChecked = event.target.checked;
  }

  getUserCount(){
    let count = 0
    for(let i = 0;i<this.customersList.length;i++){
      if(this.customersList[i].isChecked == true){
       count += 1;
      }
    }
    for(let i = 0;i<this.marketingDataUser.length;i++){
      if(this.marketingDataUser[i].isChecked == true){
       count += 1;
      }
    }
    for(let i = 0;i<this.keyAndValue.length;i++){
      if(this.keyAndValue[i].isChecked == true){
       count += 1;
      }
    }
    this.userSelectCount = count;
  }

  getOfferById1(id:any){
    this.generic_service.getOfferById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleOfferData = []
        this.singleOfferData.push(response.response)
        this.editForm.patchValue({
          name: response.response.name,
          description: response.response.description,
        })
        console.log(this.editForm.value)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  onItemSelect(item: any) {
    // for(let i=0; i<this.usersList.length;i++) {
    //   if(this.usersList[i].userType == item.roleName){
    //     this.usersList[i].isChecked = true;
    //     this.usersList_2[i].isChecked = true;
    //   }
    // }
    // this.getUserCount()
    console.log(item)
    for(var i = 0; i < this.params.length;i++){

    }
  }

  onItemDeSelect(item: any) {
    for(let i=0; i<this.customersList.length;i++) {
      if(this.customersList[i].userType == item.roleName){
        this.customersList[i].isChecked = false;
        this.usersList_2[i].isChecked = false;
      }
    }
    this.getUserCount()
  }

  onSelectAll(items: any) {
  }

  searchUser(){
    console.log(this.userSearchInput)
    if(this.userSearchInput != ""){
      const filtered = this.customersList.filter((list: any) => list.userName == this.userSearchInput);
    }else{
      this.customersList = this.usersList_2;
    }
  }

  customerSelected(index:any,event:any){
    this.customersList[index].isChecked = event.target.checked;
    this.getUserCount()
  }

  keyValueSelected(index:any,event:any){
    this.keyAndValue[index].isChecked = event.target.checked;
    this.keyAndValue[index].isChecked = event.target.checked;
    this.getUserCount()
  }

  sendOffer(){
    let phoneList:any = []
    for(let i = 0;i<this.customersList.length;i++){
      if(this.customersList[i].isChecked == true){
        phoneList.push(String(this.customersList[i].mobileNo1))
      }
    }

    for(let i = 0;i<this.marketingDataUser.length;i++){
      if(this.marketingDataUser[i].isChecked == true){
        phoneList.push(String(this.marketingDataUser[i].mobileNo1))
      }
    }

    let body = {
      "scheduleId": this.offerId,
      "phoneList": phoneList
    }
    console.log(body)
    this.generic_service.sendWhatsappMessageForScheduleDetail(body).subscribe(
      (res:any)=>{
        this.cancelModel()
        this.toastr.success(res.message)
      },
      (err:any)=> {
        console.log(err);
        document.getElementById("closeWhatsappModel")?.click()
        document.getElementById("closeModalDetails")?.click()
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  getParams() {
    this.generic_service.predefinedParameter('CUSTREG').subscribe(
      (response:any)=>{
        console.log(response)
        for(let key in response.response){
          response.response[key].possibleValueSelected = ""
        }
        this.params = response.response;
        console.log(this.params)
        // this.paramList = response.response;
        // console.log(this.paramList)

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  addParam(){
    this.paramList.push({
      "id": 0,
      "name": "",
      "possibleValue": [],
      "possibleValueSelected": ""
    })
    console.log(this.paramList)
  }

  removeParam(index:any){
    this.paramList.splice(index,1)
  }

  addCustomerParam(){
    this.customerParamList.push({
      "id": 0,
      "name": "",
      "possibleValue": [],
      "possibleValueSelected": ""
    })
    console.log(this.customerParamList)
  }

  removeCustomerParam(index:any){
    this.customerParamList.splice(index,1)
  }

  changeUserType(type:any){
    this.usersType = String(type)
  }

  paramSelect(event:any,index:any){
    console.log(event)
    console.log(event.target.value)

    this.paramList[index].id = Number(event.target.value)
    console.log(event.target.value)
    for(var i=0; i<this.params.length;i++) {
      if(this.params[i].id == Number(event.target.value)){
        this.paramList[index].name = this.params[i].name
        this.paramList[index].possibleValue = this.params[i].possibleValue
      }
    }
    console.log(this.paramList)
    // this.possibleValueSelected = ""
    // if(this.paramSelected != ''){
    //   for(var i=0; i<this.params.length;i++) {
    //     if(this.params[i].id == Number(this.paramSelected)){
    //       this.possibleValue = this.params[i].possibleValue
    //     }
    //   }
    //   console.log(this.possibleValue)
    // }else{
    //   this.possibleValue = [];
    //   this.possibleValueSelected = ""
    // }
  }

  customerParamSelect(event:any,index:any){
    console.log(event)
    this.customerParamList[index].id = Number(event.target.value)
    console.log(event.target.value)
    for(var i=0; i<this.params.length;i++) {
      if(this.params[i].id == Number(event.target.value)){
        this.customerParamList[index].name = this.params[i].name
        this.customerParamList[index].possibleValue = this.params[i].possibleValue
      }
    }
    console.log(this.paramList)
    // this.possibleValueSelected = ""
    // if(this.paramSelected != ''){
    //   for(var i=0; i<this.params.length;i++) {
    //     if(this.params[i].id == Number(this.paramSelected)){
    //       this.possibleValue = this.params[i].possibleValue
    //     }
    //   }
    //   console.log(this.possibleValue)
    // }else{
    //   this.possibleValue = [];
    //   this.possibleValueSelected = ""
    // }
  }

  selectMarketingUser(index:any,event:any){
    this.marketingDataUser[index].isChecked = event.target.checked;
    this.getUserCount()
  }

  getMarketingData(){
    this.paramList = []
    this.addParam()
    this.generic_service.getMarketingData().subscribe(
      (response : any) => {
        console.log(response);
        for(let i = 0;i<response.response.length;i++){
          response.response[i].isChecked = false;
        }
        this.marketingDataUser = response.response;
        console.log(this.marketingDataUser)
      },
      (error : any) => {
        console.log(error)
      }
    )
  }

  getMarketingDataByKeyAndValue(){
    let keyValueList: any= []
    this.keyValueSearched = true;
    for(let i = 0;i<this.customerParamList.length;i++){
      let arr = {
        "key": String(this.customerParamList[i].name),
        "value":  String(this.customerParamList[i].possibleValueSelected)
      }
      keyValueList.push(arr)
    }
    let body = {
      "cid": Number(localStorage.getItem('cid')),
      "keyValueList": keyValueList
    }
    console.log(body)
    this.generic_service.getByKeyAndValue(body).subscribe(
      (response : any) => {
        console.log(response);
        for(let i = 0;i<response.response.length;i++){
          response.response[i].isChecked = false;
        }
        this.marketingDataUser = response.response;
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllCustomers(){
    this.customerParamList = []
    this.addCustomerParam()
    this.generic_service.getCustomerInfo(0,20).subscribe(
      (response : any) => {
        console.log(response);
        for(let i = 0;i<response.response.length;i++){
          response.response[i].isChecked = false;
        }
        this.customersList = response.response;
        console.log(this.customersList)
      },
      (error : any) => {
        console.log(error)
      }
    )
  }

  getCustomersByKeyAndValue(){
    let keyValueList: any= []
    for(let i = 0;i<this.paramList.length;i++){
      let arr = {
        "key": String(this.paramList[i].name),
        "value":  String(this.paramList[i].possibleValueSelected)
      }
      keyValueList.push(arr)
    }
    let body = {
      "cid": Number(localStorage.getItem('cid')),
      "keyValueList": keyValueList
    }
    console.log(body)
    this.generic_service.getByKeyAndValue(body).subscribe(
      (response : any) => {
        console.log(response);
        for(let i = 0;i<response.response.length;i++){
          response.response[i].isChecked = false;
        }
        this.customersList = response.response;
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  del(id:any){
    this.offerId = id
  }

  deleteOffer(){
    this.generic_service.deleteOffer(this.offerId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllOffer()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }


  updateOffer(){
    this.editFormSubmitted = true;
    if(!this.editForm.valid){
      console.log(this.editForm.value)
      return
    }
    this.addButton = true;
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "id": this.singleOfferData[0].id,
      "offersId": this.singleOfferData[0].offersId,
      "name": String(this.editForm.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.updateOffer(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllOffer()
        this.cancelModel()
        this.editForm.reset()
        this.editFormSubmitted = false;
        this.addButton = false;
        this.toastr.success("Successfully Updated")
      },
      (error:any)=>{
        console.log(error)
        this.addButton = false;
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }
}